import rona5_1 from "./5x10/rona5 (1)_1.webp";
import rona5_2 from "./5x10/rona5 (2).webp";
import rona5_3 from "./5x10/rona5 (3).webp";
import rona5_4 from "./5x10/rona5 (4).webp";
import rona5_5 from "./5x10/rona5 (5).webp";
import rona5_6 from "./5x10/rona5 (6).webp";
import rona5_7 from "./5x10/rona5 (7).webp";
import rona5_8 from "./5x10/rona5 (8).webp";
import rona5_9 from "./5x10/rona5 (9).webp";
import rona5_10 from "./5x10/rona5 (10).webp";
import rona3 from "./10x10.webp";
import rona4 from "./10x10 (2).webp";

const Rona5Images = [
  rona5_1,
  rona5_6,
  rona5_5,
  rona5_7,
  rona5_8,
  rona5_9,
  rona5_10,
  rona5_2,
  rona5_3,
  rona5_4,
];
const Rona10Images = [rona3, rona4];

export { Rona10Images, Rona5Images };
